import { render, staticRenderFns } from "./board_blank_state.vue?vue&type=template&id=7d1f5e3f&"
import script from "./board_blank_state.vue?vue&type=script&lang=js&"
export * from "./board_blank_state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "board_blank_state.vue"
export default component.exports